
import { Options, setup, Vue } from 'vue-class-component';
import ProductDetail from '@/components/dialogs/ProductDetail.vue';
import ErroDialog from '@/components/dialogs/ErrorDialog.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import { onMounted } from 'vue';
import { useConfirm } from 'primevue/useconfirm';
import { useStore } from 'vuex';
import { Actions } from './config/store.config';
import appconfigService from './services/appconfig/appconfig.service';
import { kioskService } from './services/kiosk/kiosk.service';
import { getPaymentUtil } from './utils/payment/payment-provider';
import { useRoute, useRouter } from 'vue-router';
import UnlockDialog from './components/dialogs/UnlockDialog.vue';
import LanguageSelector from './components/LanguageSelector.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

@Options({
  components: {
    ProductDetail,
    ConfirmDialog,
    ErroDialog,
    UnlockDialog,
    LanguageSelector,
  },
})
export default class App extends Vue {
  context = setup(() => {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const confirm = useConfirm();
    const { t } = useI18n();
    const language = computed(() => store.getters.currentLanguage ?? 'es');

    const fetchConfig = async () => {
      await router.isReady();
      const id = route.query.id?.toString() ?? '';

      const isConfigured = store.getters.isConfigured;
      if (!id && !isConfigured) {
        throw new Error(t('errors.missingConfiguration'));
      } else if (id) {
        const config = await kioskService.getConfig(id);
        store.dispatch(Actions.SET_GENERAL_CONFIG, config);
        return;
      }

      const branchId = store.getters.branchId;
      if (branchId) {
        const config = await kioskService.getBranchConfig(branchId);
        if (config) {
          store.dispatch(Actions.SET_BRANCH_DATA_CONFIG, config);
        }
      }
    };

    onMounted(async () => {
      const appconfig = await appconfigService.get();
      const timerSeconds = +(
        appconfig.DataConfig?.constants?.constantDefaultKioskResetTime ?? 90
      );

      const body = document.querySelector('body');
      body?.addEventListener('contextmenu', (ev) => {
        ev.preventDefault();
      });

      try {
        await fetchConfig();
      } catch (error: any) {
        confirm.require({
          message: error.message,
          header: t('common.configuration'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: t('common.accept'),
          rejectClass: 'btn-clean none',
          accept: () => {
            window.location.reload();
          },
          reject: () => {
            window.location.reload();
          },
        });

        return;
      }

      let timer: any = null;
      const reset = () => {
        store.dispatch(Actions.HIDE_ALL_DIALOG);
        store.dispatch(Actions.HIDE_ALL_ERRORS);

        confirm.close();

        const branchId = store.getters.branchId;
        if (branchId) {
          kioskService
            .getBranchConfig(branchId)
            .then((config) => {
              store.dispatch(Actions.SET_BRANCH_DATA_CONFIG, config);
            })
            .catch(() => {
              // ignore
            });
        }

        router.push('/');
      };

      const sessionWarning = () => {
        const softRsetRoutes = ['home'];
        if (softRsetRoutes.includes(route.name as string)) {
          reset();
          setTimer();
          return;
        }

        const excludedRoutes = ['payment', 'refund'];
        if (excludedRoutes.includes(route.name as string)) return;

        // store.dispatch(Actions.HIDE_ALL_DIALOG)
        // store.dispatch(Actions.HIDE_ALL_ERRORS)
        confirm.close();

        const warningTimer = setTimeout(() => {
          reset();
          setTimer();
        }, timerSeconds * 1000);

        confirm.require({
          header: t('session.present'),
          message: t('session.expiration'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: t('common.continue'),
          rejectClass: 'btn-clean',
          rejectLabel: t('session.exit'),
          accept: () => {
            clearTimeout(warningTimer);
            setTimer();
          },
          reject: () => {
            clearTimeout(warningTimer);
            reset();
            setTimer();
          },
        });
      };

      const setTimer = () => {
        clearTimeout(timer);
        timer = null;

        timer = setTimeout(sessionWarning, timerSeconds * 1000);
      };

      setTimer();
      body?.addEventListener('click', () => {
        setTimer();
      });

      const paymentUtil = getPaymentUtil();
      if (!paymentUtil.initOnStart) {
        return;
      }

      paymentUtil
        .init()
        .then((data) => {
          // oxlint-disable-next-line no-console
          console.log(data);
        })
        .catch((err) => {
          confirm.require({
            message: err,
            header: 'PINPAD',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: t('common.accept'),
            rejectClass: 'btn-clean none',
            accept: () => {
              window.location.reload();
            },
            reject: () => {
              window.location.reload();
            },
          });
        });
    });

    return { language };
  });
}
